import { render } from "./Value3Section.vue?vue&type=template&id=759c7cc6&scoped=true"
import script from "./Value3Section.vue?vue&type=script&lang=js"
export * from "./Value3Section.vue?vue&type=script&lang=js"

import "./Value3Section.vue?vue&type=style&index=0&id=759c7cc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759c7cc6"]])

export default __exports__